import React, { useMemo, useState } from 'react';
import styles from './LeagueName.module.scss';
import Icon from '../../Favorite/Icon/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { modifyFavoriteLeague } from '../../../../../../store/actions/favorites';
import classNames from 'classnames';

const LeagueName = ({ categoryName, leagueName, leagueId, countryCode }) => {
    const dispatch = useDispatch();

    const favoriteLeagues = useSelector(state => state.favorites.leagues);
    const isESports = useSelector(state => state.sportEvents.isESports);

    const [isSavingFavoriteState, setIsSavingFavoriteState] = useState(false);

    const isFavorite = useMemo(() => {
        return favoriteLeagues.includes(leagueId);
    }, [favoriteLeagues, leagueId]);

    const onFavoriteIconClick = async () => {
        if (isSavingFavoriteState) return;
        setIsSavingFavoriteState(true);

        const params = { leagueId };

        if (isFavorite) {
            params.actionType = 'delete';
        }

        await dispatch(modifyFavoriteLeague({ params, isAlreadyFavorite: isFavorite }));

        setIsSavingFavoriteState(false);
    };

    return (
        <th colSpan='4' align='left'>
            <div className={'flex align-center'}>
                <div className={styles.leagueName}>
                    <div className={classNames(styles.flagContainer)}>
                        <img
                            alt={countryCode}
                            src={`/assets/flags/${
                                countryCode?.trim() ? countryCode.toLowerCase() : 'int'
                            }.svg`}
                            className={styles.flag}
                        />
                    </div>
                    <div>
                        {categoryName}, {leagueName}
                    </div>
                </div>
                {!isESports && (
                    <Icon
                        isFavorite={isFavorite}
                        className={'m-l-3'}
                        onClick={onFavoriteIconClick}
                    />
                )}
            </div>
        </th>
    );
};

export default LeagueName;
